import { Component, OnInit, Input } from "@angular/core"
import { Store, Action } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { EnquiriesStore } from "@store/enquiries"
import { Observable } from "rxjs/Observable"
import { Enquiry } from "@models/enquiry"
import {
  RESET_ENQUIRY_ERRORS,
  UPDATE_ENQUIRY,
  CREATE_ENQUIRY,
  REPLACE_ENQUIRY,
  ADD_ENQUIRY
} from "@reducers/enquiries"
import { EnquiryEffects } from "@reducers/effects/enquiry"
import { ModalService } from "@services/modal"
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer"
import {
  CONTACT_GENDERS,
  CONTACT_TYPES,
  CONTACT_GRADES
} from "@constants/contacts"
import { SCHOOLS } from "@constants/schools";
import {
  ENQUIRY_STATUSES,
} from "@constants/enquiries"
import { ConstantsHelpers, ConstData } from "@constants/helpers"

@Component({
  selector: 'enquiry-form',
  templateUrl: './enquiry-form.pug',
})
export class EnquiryFormComponent implements OnInit {

  @Input() public isInEditMode: boolean = false

  public enquiriesStore: Observable<EnquiriesStore>
  public enquiry: Enquiry = new Enquiry()

  public parentGenderSearchStr: string
  public studentGenderSearchStr: string
  public gendersCompleter: CompleterData
  public genders: ConstData[] = CONTACT_GENDERS

  public contactTypesSearchStr: string
  public contactTypesCompleter: CompleterData
  public contactTypes: ConstData[] = CONTACT_TYPES.filter((c: ConstData) => c.value !== 2)

  public gradeSearchStr: string
  public gradeCompleter: CompleterData
  public grades: ConstData[] = CONTACT_GRADES

  public schoolSearchStr: string
  public schoolCompleter: CompleterData
  public schools: ConstData[] = SCHOOLS

  public enquiryStatusSearchStr: string
  public enquiryStatusesCompleter: CompleterData
  public enquiryStatuses: ConstData[] = ENQUIRY_STATUSES

  constructor(
    private store: Store<AppState>,
    private enquiryEffects: EnquiryEffects,
    private modalService: ModalService,
    private completerService: CompleterService,
    public constantsHelpers: ConstantsHelpers,
  ) {
    this.gendersCompleter =
      this.completerService.local(this.genders, "title", "title")

    this.contactTypesCompleter =
      this.completerService.local(this.contactTypes, "title", "title")

    this.gradeCompleter =
      this.completerService.local(this.grades, "title", "title")

    this.schoolCompleter =
      this.completerService.local(this.schools, "title", "title")

    this.enquiryStatusesCompleter =
      this.completerService.local(this.enquiryStatuses, "title", "title")
  }

  ngOnInit() {
    this.enquiriesStore = this.store.select("enquiriesReducer")
    this.enquiriesStore.subscribe(
      (s: EnquiriesStore) => this.enquiry = s.editableEnquiry)

    this.setupEffectEvents()
  }

  setupEffectEvents() {
    Observable.merge(this.enquiryEffects.updateEnquiry,
      this.enquiryEffects.createEnquiry)
      .subscribe((action: Action) => {
        switch(action.type) {
          case ADD_ENQUIRY:
            this.modalService.closeModal()
            break
          case REPLACE_ENQUIRY:
            this.modalService.closeModal()
            break }
      })
  }

  clickedSubmitForm(e: MouseEvent) {
    e.preventDefault()
    this.store.dispatch({ type: RESET_ENQUIRY_ERRORS, payload: this.enquiry })

    if (this.isInEditMode) {
      this.store.dispatch({ type: UPDATE_ENQUIRY, payload: this.enquiry })
    } else {
      this.store.dispatch({ type: CREATE_ENQUIRY, payload: this.enquiry })
    }
  }

  getHeader() {
    return this.isInEditMode ? `Editing ${this.enquiry.studentFirstName}` : "New enquiry"
  }

  isTypeSelected(contactType: string): boolean {
    return this.enquiry.quickContactType == contactType
  }

  clickedTypeOption(contactType: string) {
    return this.enquiry.quickContactType = contactType
  }

  selectedStudentGender(e: CompleterItem) {
    if (e) {
      this.enquiry.studentGender = e.originalObject.value || "0" }
  }

  selectedParentGender(e: CompleterItem) {
    if (e) { this.enquiry.parentGender = e.originalObject.value || "0" }
  }

  selectedPreferredContact(e: CompleterItem) {
    if (e) { this.enquiry.preferredContact = e.originalObject.value }
  }

  selectedGrade(e: CompleterItem) {
    if (e) { this.enquiry.grade = e.originalObject.value }
  }

  selectedSchool(e: CompleterItem) {
    if (e) { this.enquiry.school = e.originalObject.value }
  }

  selectedEnquiryStatus(e: CompleterItem) {
    if (e) { this.enquiry.enquiryStatus = e.originalObject.value }
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/enquiry-form.ts